/* eslint-disable import/prefer-default-export */
/* eslint-disable func-names */
import axios from 'axios';
// helpers
import { getCookie, getParamsUrlString } from '../helpers';

export function* callApiServiceCommon(payload) {
  const urlHref = getCookie();
  const url = payload.url;
  const method = payload.method;
  const params = payload.params;
  const domain = getParamsUrlString(urlHref, 'shop');
  params.shop_domain = yield domain;

  if (typeof params !== 'object') {
    return yield;
  }
  const Array = Object.keys(params);
  // POST
  if (method === 'POST') {
    const bodyFormData = new FormData();
    Array.forEach(element => {
      bodyFormData.append(element, params[element]);
    });
    return yield axios({
      method,
      url,
      data: bodyFormData,
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: urlHref
      }
    })
      .then(response => {
        return response.status === 200 ? response.data : '';
      })
      .catch(error => {
        console.log(error);
      });
  }
  // GET
  return yield axios({
    method: 'get',
    url,
    params,
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: urlHref
    }
  })
    .then(function (response) {
      return response.status === 200 ? response.data : [];
    })
    .catch(function () {
      return [];
    });
}
